var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  ScreenFilterSingleoption: () => ScreenFilterSingleoption
});
var import_screen = __toModule(require("./screen"));
var import_kamiSama = __toModule(require("../../kamiSama"));
class ScreenFilterSingleoption extends import_screen.Screen {
  constructor(samaData, samaForm, screenName, navigationIndex) {
    super(samaData, samaForm, screenName, navigationIndex);
    this.samaData = samaData;
    this.samaForm = samaForm;
    this.screenName = screenName;
    this.navigationIndex = navigationIndex;
    this.validateScreen();
    this.yayoyakiId = this.screenForm.yayoyakisId[0];
  }
  getYayoyaki() {
    const yayoyakiForm = this.samaForm.getYayoyakiForm(this.yayoyakiId);
    return new import_kamiSama.YayoyakiValue(this.samaData, this.samaForm, yayoyakiForm, this.navigationIndex || 0);
  }
  setYayoyakiValue(value) {
    this.getYayoyaki().setValue(value);
  }
  validateScreen() {
    var _a;
    const yayoyakisLength = (_a = this.screenForm.yayoyakisId) == null ? void 0 : _a.length;
    if (yayoyakisLength > 1) {
      throw new Error(`ScreenFilterSingleoption: screen ${this.screenName} has more than one Yayoyaki, must have only one.`);
    }
    if (!yayoyakisLength) {
      throw new Error(`ScreenFilterSingleoption: screen ${this.screenName} has no Yayoyaki defined, must have one (only one).`);
    }
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ScreenFilterSingleoption
});
